'use client';

import Box from '@mui/material/Box';
import {CardSkeleton} from './CardSkeleton';

// The responsive card grid shared by every listing (1 / 2 / 3 columns, gap 4) —
// mirrors ListingGrid's Grid so the skeleton grid lines up with the real one.
// Defaults to 9 cards, matching the listings' pagination page size (the first
// paint) so the grid doesn't grow by a row when data arrives. CardSkeleton is
// flat by default, so this grid applies the shadow to its children, mirroring
// ListingGrid.
export function CardGridSkeleton({count = 9}: {count?: number}) {
  return (
    <Box
      sx={theme => ({
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: theme.spacing(4),
        [theme.breakpoints.up('sm')]: {gridTemplateColumns: 'repeat(2, 1fr)'},
        [theme.breakpoints.up('md')]: {gridTemplateColumns: 'repeat(3, 1fr)'},
        '& > *': {boxShadow: theme.customShadows.card},
      })}
    >
      {Array.from({length: count}, (_, i) => (
        <CardSkeleton key={i} />
      ))}
    </Box>
  );
}

CardGridSkeleton.displayName = 'CardGridSkeleton';
